module.exports = __webpack_public_path__ + "plus-2021jump/images/click_on_the_icon_txt.35198dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/click_on_the_icon_txt.png
// module id = jFv4
// module chunks = 0